import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "size", "color", "id", "disabled", "onClick"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { defaultMemoize } from 'reselect';
import PropTypes from 'prop-types';
import _values from 'lodash/values';
import _noop from 'lodash/noop';
import _isFunction from 'lodash/isFunction';
import cx from 'classnames';

// Constants
import { SIZES, SIZE_TO_CLASSNAME } from './Icon.constants';
import styles from './icon.module.scss';
var Icon = /*#__PURE__*/function (_PureComponent) {
  _inherits(Icon, _PureComponent);
  var _super = _createSuper(Icon);
  function Icon() {
    var _this;
    _classCallCheck(this, Icon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getIconStyle", defaultMemoize(function (color) {
      return {
        color: color
      };
    }));
    _defineProperty(_assertThisInitialized(_this), "getIconProps", defaultMemoize(function (onClick, disabled) {
      if (_isFunction(onClick)) {
        return {
          onClick: disabled ? _noop : onClick,
          role: 'button',
          tabIndex: -1 // tab-index click wont work becoz of this css-content way of setting icons
        };
      }

      return null;
    }));
    return _this;
  }
  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        size = _this$props.size,
        color = _this$props.color,
        id = _this$props.id,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var sizeClassName = SIZE_TO_CLASSNAME[size];
      var iconClassName = cx(className, sizeClassName, children);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: cx(iconClassName, _defineProperty({}, styles.disabledIcon, disabled)),
        style: this.getIconStyle(color)
      }, this.getIconProps(onClick, disabled), restProps));
    }
  }]);
  return Icon;
}(PureComponent);
_defineProperty(Icon, "SIZES", SIZES);
Icon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(_values(SIZES)),
  children: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  id: PropTypes.string,
  color: PropTypes.string
};
Icon.defaultProps = {
  className: '',
  size: SIZES.MD,
  children: '',
  onClick: null,
  // didnt use _noop so taht the getIconProps works as expected
  disabled: false,
  id: undefined,
  color: undefined
};
export default Icon;